import ToBooleanText from '../../components/utilities/Table/helperKIvaTable';
import { RequestWarranty } from '../../components/utilities/Table/generalColumns/RequestWarranty';

const commonColumns = [
    RequestWarranty,
    ToBooleanText('tramite', 'Tramite voluntario', 'tramite_voluntario'),
    {
        Header: 'Nro crédito',
        accessor: 'solicitud.codigo_gyg',
    },
    {
        Header: 'Identificación',
        accessor: 'solicitud.persona.numero_identificacion',
    },

    {
        Header: 'Cliente',
        accessor: 'solicitud.persona.full_name',
        typeId: 'HeaderClient',
    },

    {
        Header: 'Producto',
        accessor: 'solicitud.subproducto.label',
    },

    {
        Header: 'Estado',
        accessor: 'estado.label',
    },
];

const requestsWarrantyList = [
    {
        id: 'bolsa_general',
        label: 'BOLSA GENERAL',
        responsable: false,
        status: '3',
        offices: true,
        columns: commonColumns,
        registrationLimit: 5,
        buttonAction: [{ name: 'takeRequestWarranty' }],
    },
    // {
    //     id: 'proceso',
    //     label: 'EN PROCESO',
    //     offices: true,
    //     responsable: true,
    //     columns: commonColumns,
    //     registrationLimit: 5,
    // },
    {
        id: 'proceso',
        label: 'EN PROCESO',
        offices: true,
        responsable: true,
        columns: commonColumns,
        registrationLimit: 5,
        nameColumnProcessed: [
            {
                name: 'estado',
                value: 3,
                operator: '%26',
            },
            {
                name: 'responsable',
                value: 'user',
            },
        ],
    },
    {
        id: 'procesadas',
        label: 'PROCESADAS',
        offices: true,
        responsable: false,
        columns: commonColumns,
        registrationLimit: 5,
        nameColumnProcessed: [
            {
                name: 'estado',
                value: 4,
                operator: '%26',
            },
            {
                name: 'usuario_juridico',
                value: 'user',
                operator: '%26',
            },
        ],
    },
];
export default requestsWarrantyList;
